import {styled} from "@mui/material";

export const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  padding:  0 16px 16px 16px;
  box-sizing: border-box;
  
`;

export const ContainerRow = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
`;

export const LinkElem = styled('a')`
  color: #3066F0;
  text-decoration: none;
  text-underline: none;
`;
